module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-57x57-e27c91ecc99088ebdc1c1fb4f79f3080.png";